import { CALENDAR_DISPLAY, CALENDAR_DISPLAY_OPTIONS } from 'components/Modals/CustomBookingPage/BookingPageOptions'
import { DEFAULT_ENTRY_POINT_KEY } from 'components/Modals/CustomBookingPage/EntryPointSelector'
import {
    ENTRY_WITH_CATEGORY,
    INTRO_MESSAGE_KEY,
    SHOW_INTRO_BORDER,
} from 'components/Modals/CustomBookingPage/GeneralForm'
import { useTenantContext } from 'context/TenantContext'
import { useRouter } from 'next/router'
import React, { useContext, useEffect, useState } from 'react'
import { getApiRequest } from 'utils/fetch-helper'
import { ONE_DAY_IN_MS } from 'utils/scheduling-helper'
import { toYmd } from 'utils/string-localization-helper'
import {
    BookingPageContext,
    BookingPageProvider,
} from './BookingPageContext'
import Cookies from 'js-cookie'
import { convertToAccountTimeZone } from 'utils/date-and-time-helper'

const enum Page {
    APPOINTMENTS = "APPOINTMENTS",
    CLASSES = "CLASSES",
}

export const getDateFromYmd = (dt: string) => {
    const ymd = dt as unknown as string
    if (ymd) {
        const [y, m, d] = ymd?.split('-') as unknown[] as number[]
        return new Date(y, m - 1, d, 0, 0, 0, 0)
    } else
        return new Date(
            new Date().getFullYear(),
            new Date().getMonth(),
            new Date().getDate(),
            0,
            0,
            0,
            0
        )
}
let active_week = new Date()
let selected_date = new Date()
let param_date: Date

function BookingPageContainer({ children }: any) {
    const router = useRouter()
    const { db_settings, tenant } = useTenantContext()
    const [currentLocation, setCurrentLocation] = useState('')
    const [defaultEntryPoint, setDefaultEntryPoint] = useState('LOCATIONS')
    const [calendarDisplay, setCalendarDisplay] = useState(CALENDAR_DISPLAY_OPTIONS[0].value)
    const [isEntryByCategory, setIsEntryByCategory] = useState(false)
    const [selectedClasses, setSelectedClasses] = useState<string[]>([])
    const [selectedAppointments, setSelectedAppointments] = useState<
        string[]
    >([])

    const [selectedStaff, setSelectedStaff] = useState<string[]>([])
    const [selectedMemberships, setSelectedMemberships] = useState<
        string[]
    >([])
    const [isExpanded, setIsExpanded] = useState(false)
    const [introMessage, setInroMessage] = useState('')
    const [shouldRefetch, setShouldRefetch] = useState(false)
    const [showIntroBorder, setShowIntroBorder] = useState(false)
    const [class_avail_dates, setClassAvailDates] = useState<string[]>([])
    const [appt_avail_dates, setApptAvailDates] = useState<string[]>([])
    const [prev_location, setPrevLocation] = useState<string>() //TODO: refactor to a map maybe?
    const [prev_service, setPrevService] = useState<string>()
    const [get_avails_lock, toggleGetAvailsLock] = useState<boolean>(false)
    const timezone = Cookies.get('timezone') || 'America/New_York'

    const currentDate = convertToAccountTimeZone(timezone, new Date()) || new Date();

    useEffect(() => {
        const found = db_settings?.content?.find(
            (item: any) => item?.name == DEFAULT_ENTRY_POINT_KEY
        )
        if (found) {
            setDefaultEntryPoint(found?.value)
        }

        const found_display = db_settings?.content?.find(
            (item: any) => item.name === CALENDAR_DISPLAY
        )
        if (found_display) {
            setCalendarDisplay(found_display?.value)
        }
    }, [db_settings])

    useEffect(() => {
        const found = db_settings?.content?.find(
            (item: any) => item?.name === ENTRY_WITH_CATEGORY
        )
        if (found) {
            setIsEntryByCategory(found?.value == 'true' ? true : false)
        }

        handleDefaultIntroMessage()
        handleDisplayIntroBorder()
    }, [db_settings])

    useEffect(() => {
        if (router.query.d) {
            param_date = getDateFromYmd(
                router.query?.d as unknown as string
            )
            active_week = param_date
            if (active_week < new Date(currentDate)) {
                active_week = new Date(currentDate)
            } else {
                selected_date = active_week
            }
        }
    }, [router.query])

    const [activeDate, setActiveDate] = useState<Date>(selected_date)
    const [toDate, setToDate] = useState<Date>(
        new Date(
            new Date(currentDate).setTime(new Date(currentDate).getTime() + ONE_DAY_IN_MS * 8)
        )
    )
    const [fromDate, setFromDate] = useState<Date>(new Date())
    const [isPrivate, setIsPrivate] = useState(false)

    useEffect(() => {
        if (router?.query?.d) {
            if (
                router.query.d != toYmd(activeDate) &&
                toYmd(param_date) >= toYmd(new Date(currentDate))
            ) {
                setActiveDate(getDateFromYmd(router.query.d as string))
            }
        } else if (
            router.pathname.startsWith('/book/') &&
            (tenant?.id?.length || 0) > 0 &&
            router?.query?.l
        ) {
            getFirstAvailDate()
        }
    }, [router.query.d, tenant?.id])

    useEffect(() => { // always get first avail date when changing service
        if (router?.query?.d
            && router.query.d.length > 0
            && router?.query?.l
            && (router.pathname.includes('/appointments')
                && router?.query?.s
                && router.query.s != prev_service)) {
            getFirstAvailDate()
        }
    }, [router.query.s])

    useEffect(() => {
        if (router?.query?.d
            && router.query.d.length > 0
            && router?.query?.l
            && router.query.l != prev_location) {
            getFirstAvailDate()
        }
    }, [router.query.l])

    useEffect(() => {
        const is_appt = router.pathname.includes('/appointments')
        const to_ymd = toYmd(toDate)
        const from_ymd = toYmd(fromDate)
        if (
            !get_avails_lock &&
            router.query.l &&
            (is_appt
                ?
                router.pathname.startsWith("/book/client")
                ||
                (appt_avail_dates.length == 0
                    || to_ymd >
                    appt_avail_dates[appt_avail_dates.length - 1]
                    || from_ymd <
                    appt_avail_dates[0]
                )
                && router.query.s
                :
                (class_avail_dates.length == 0
                    || to_ymd >
                    class_avail_dates[class_avail_dates.length - 1]
                    || from_ymd <
                    class_avail_dates[0]
                ))
        ) {
            try {
                getAvailabilities(is_appt, from_ymd)
            } catch (err) { }
        }
    }, [fromDate, toDate])

    async function getAvailabilities(is_appt: boolean, from_date: string) {
        try {
            toggleGetAvailsLock(true)
            const locationId = router.query.l
            const serviceId = router.query.s || router.query.classId
            let res: string[] = await getApiRequest(
                `/v1/offerings/get-avail-dates?date=${from_date}&locationId=${locationId}${is_appt ? `&serviceId=${serviceId}` : ""}`
            )
            if (res?.length > 0) {
                res.sort()
            }
            if (is_appt) {
                setApptAvailDates(res)
            } else {
                setClassAvailDates(res)
            }
        } catch (error) {

        } finally {
            toggleGetAvailsLock(false)
        }
    }

    async function getFirstAvailDate() {
        try {
            const locationId = router.query.l
            const serviceId = router.query.s || router.query.classId
            setPrevLocation(router?.query?.l as string)
            setPrevService(serviceId as string)
            let res: any = await getApiRequest(
                `/v1/offerings/get-first-avail-date?&locationId=${locationId}${serviceId ? `&serviceId=${serviceId}` : ''}`
            )
            if (!res || res.error) {
                res = toYmd(new Date(currentDate))
            }
            if (!router.query.d || res > router.query.d) {
                router.replace({
                    query: {
                        ...router.query,
                        d: res,
                    },
                })
                const res_date = new Date(res)
                setFromDate(res_date)
                setToDate(
                    new Date(
                        new Date(currentDate).setTime(res_date.getTime() + ONE_DAY_IN_MS * 8)
                    )
                )
            } else {
                getAvailabilities(router.pathname.includes('/appointments'), res)
            }
        } catch (error) {

        }
    }

    const handleDefaultIntroMessage = () => {
        const found = db_settings?.content?.find(
            (item: any) => item.name === INTRO_MESSAGE_KEY
        )

        if (found) {
            setInroMessage(found?.value)
        }
    }

    const handleDisplayIntroBorder = () => {
        const found = db_settings?.content?.find(
            (item: any) => item.name === SHOW_INTRO_BORDER
        )
        if (found) {
            setShowIntroBorder(found?.value == 'true' ? true : false)
        }
    }

    const contextValue = {
        currentLocation,
        setCurrentLocation,
        selectedClasses,
        setSelectedClasses,
        selectedAppointments,
        setSelectedAppointments,
        selectedStaff,
        setSelectedStaff,
        selectedMemberships,
        setSelectedMemberships,
        activeDate,
        setActiveDate,
        toDate,
        setToDate,
        fromDate,
        setFromDate,
        router,
        isExpanded,
        setIsExpanded,
        isPrivate,
        setIsPrivate,
        defaultEntryPoint,
        setDefaultEntryPoint,
        isEntryByCategory,
        setIsEntryByCategory,
        introMessage,
        setInroMessage,
        showIntroBorder,
        setShowIntroBorder,
        shouldRefetch,
        setShouldRefetch,
        class_avails: class_avail_dates,
        appt_avail_dates,
        calendarDisplay,
        setCalendarDisplay,
    }

    return (
        <BookingPageProvider value={contextValue}>
            {children}
        </BookingPageProvider>
    )
}

export default BookingPageContainer

export const useBookingPageContext = () => useContext(BookingPageContext)